import { useState } from "react";
import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  Shield,
  Users,
  BarChart3,
  Stethoscope,
  Microscope,
  Truck,
  ShieldUser,
  BookmarkCheck,
  ShieldCheck,
  Headset,
  InstagramIcon,
  Facebook,
  User,
  Star,
  ShoppingBag,
  ChevronDown,
} from "lucide-react";
import { Link } from "react-router-dom";
import skincareImg from "../../skincare.png";
import sexualHealthImg from "../../sexualhealth.png";
import hairGrowthImg from "../../hairgrowth.png";
import weightLossImg from "../../weightloss.png";
import mentalHealthImg from "../../meantalhealth1.jpg";
import whychooseimg1 from "../../why-choose-img-1.jpg";
import whychooseimg2 from "../../why-choose-img-2.jpg";
import productimg from "../../product-01-330x440.png";
import productimg1 from "../../product-02-330x440.png";
import productimg2 from "../../product-03-330x440.png";
import logo from "../../logo.png";
import { TwitterLogoIcon } from "@radix-ui/react-icons";
import SignInModal from "../../features/Login/Signin";
import CartModal from "./CartModal";
import { Tooltip } from "antd";
function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [products, setProducts] = useState([
    {
      name: "Natural Coconut Cleansing Oil",
      price: 29,
      oldPrice: 39,
      image: productimg,
      quantity: 1,
    },
    {
      name: "Super Pure",
      price: 29,
      oldPrice: 39,
      image: productimg1,
      quantity: 1,
    },
    {
      name: "Cleansing Balm",
      price: 29,
      oldPrice: 39,
      image: productimg2,
      quantity: 1,
    },
  ]);

  // Increment quantity
  const handleIncrement = (index) => {
    setProducts((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const handleDecrement = (index) => {
    setProducts((prev) =>
      prev
        .map((item, i) =>
          i === index ? { ...item, quantity: item.quantity - 1 } : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  const total = products.reduce((sum, p) => sum + p.price * p.quantity, 0);
  return (
    <>
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          {/* Logo Left */}
          <div className="text-2xl font-bold tracking-wide flex items-center">
            <img src={logo} alt="Logo" className="w-[200px] h-auto mx-auto" />
          </div>

          {/* Center Menu */}
          <nav className="bg-white">
            <div className="hidden md:flex space-x-6 items-center">
              <a href="/homepage" className="hover:text-black text-gray-700">
                Home
              </a>
              <a href="/aboutus" className="hover:text-black text-gray-700">
                About us
              </a>

              {/* Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="flex items-center text-gray-700 hover:text-black"
                >
                  Products/Treatments
                  <ChevronDown className="ml-1 w-4 h-4" />
                </button>

                {isOpen && (
                  <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-50">
                    <a
                      href="/products"
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      Hair Regrowth
                    </a>
                    <a
                      href="/products"
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      Skin Care
                    </a>
                    <a
                      href="/products"
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      Sexual Health
                    </a>
                    <a
                      href="/products"
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      Weight Loss
                    </a>
                    <a
                      href="/products"
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      Mental Health
                    </a>
                  </div>
                )}
              </div>

              <a href="#" className="hover:text-black text-gray-700">
                Medical Services
              </a>
              <a href="/ourexperts" className="hover:text-black text-gray-700">
                Our Experts
              </a>
              <a href="faqs" className="hover:text-black text-gray-700">
                FAQs
              </a>
              <a href="/blogs" className="hover:text-black text-gray-700">
                Blogs
              </a>
              <a href="/contactus" className="hover:text-black text-gray-700">
                Contact us
              </a>
            </div>
          </nav>

          {/* Right Icons */}
          <div className="flex items-center space-x-5 ml-6">
            {/* User Icon */}
            <div
              className="relative cursor-pointer"
              onClick={() => setOpen((prev) => !prev)}
            >
              <Tooltip title="Sign In" arrow>
                <User size={20} />
              </Tooltip>
            </div>

            {/* Wishlist Icon */}
            <div className="relative cursor-pointer">
              <Star size={20} />
              <span className="absolute -top-2 -right-2 bg-black text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                3
              </span>
            </div>

            {/* Cart Icon */}
            <div
              className="relative cursor-pointer"
              onClick={() => setCartOpen(true)}
            >
              <ShoppingBag size={20} />
              <span className="absolute -top-2 -right-2 bg-black text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                3
              </span>
            </div>
          </div>
        </div>
      </header>
      {open && <SignInModal onClose={() => setOpen(false)} />}
      <div className="flex items-center space-x-5 ml-6">
        <CartModal
          open={cartOpen}
          onClose={() => setCartOpen(false)}
          products={products}
          onIncrement={handleIncrement} // ✅ Pass callback
          onDecrement={handleDecrement} // ✅ Pass callback
          total={products.reduce((sum, p) => sum + p.price * p.quantity, 0)}
        />
      </div>
    </>
  );
}
export default Header;
